(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bp-beautyves-sensory"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('bp-beautyves-story')) return;
  class BeautyVesStory extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.story = this.querySelector('.bvs-story');
      this.stage = this.querySelector('.bvs-stage');
      this.beats = [...this.querySelectorAll('.bvs-beat')];
      this.toggle = this.querySelector('.bvs-toggle');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.editorSelections = new Set();
      this.visible = true;
      this.frame = 0;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.draw(); });
      };
      addEventListener('scroll', () => { if (this.visible) this.schedule(); }, {passive:true, signal});
      addEventListener('resize', this.schedule, {passive:true, signal});
      this.reduced.addEventListener('change', this.schedule, {signal});
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, {signal});
      this.addEventListener('focusin', () => {
        if (!this.paused && this.querySelector('.bvs-beats')?.contains(document.activeElement)) {
          this.paused = true;
          this.draw();
        }
      }, {signal});
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this);
      this.beats.forEach(beat => this.resizeObserver.observe(beat));
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        this.dataset.bvsVisible = String(this.visible);
        this.schedule();
      }, {rootMargin:'150px'});
      this.intersectionObserver.observe(this.story);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(this)) this.cleanup();
      }, {signal});
      document.addEventListener('shopify:section:load', event => {
        if (event.target.contains(this)) this.schedule();
      }, {signal});
      for (const type of ['shopify:section:select', 'shopify:block:select']) {
        document.addEventListener(type, event => {
          if (event.target.contains(this) || this.contains(event.target)) { this.editorSelections.add(type); this.draw(); }
        }, {signal});
      }
      for (const type of ['shopify:section:deselect', 'shopify:block:deselect']) {
        document.addEventListener(type, event => {
          if (event.target.contains(this) || this.contains(event.target)) { this.editorSelections.delete(type.replace(':deselect', ':select')); this.draw(); }
        }, {signal});
      }
      this.draw();
      this.dataset.bvsReady = 'true';
      this.dispatchEvent(new CustomEvent('bp:beautyves-story-ready', {bubbles:true}));
    }
    draw() {
      if (!this.controller) return;
      const mobile = this.clientWidth <= 700;
      const header = document.querySelector('.wt-header,.site-header,header[role=banner]');
      const top = Math.min(120, Math.max(16, header?.getBoundingClientRect().height || (mobile ? 60 : 80)));
      this.style.setProperty('--bvs-top', `${top}px`);
      const viewport = innerHeight - top;
      const enlarged = this.beats.some(beat => parseFloat(getComputedStyle(beat.querySelector('h3')).fontSize) > (mobile ? 50 : 85) || parseFloat(getComputedStyle(beat.lastElementChild).fontSize) > 23);
      const contentHeight = Math.max(...this.beats.map(beat => beat.scrollHeight));
      const motion = this.dataset.bvsVisual !== 'none' && !this.paused && !this.editorSelections.size && !this.reduced.matches && !enlarged && innerWidth >= 360 && viewport >= 650 && contentHeight < (mobile ? viewport * .56 - 105 : viewport - 200);
      this.dataset.bvsMotion = String(motion);
      const rect = this.story.getBoundingClientRect();
      const progress = motion ? Math.max(0, Math.min(1, (top - rect.top) / Math.max(1, rect.height - this.stage.offsetHeight))) : 0;
      const index = Math.min(2, Math.floor(progress * 3));
      this.beats.forEach((beat, i) => {
        beat.dataset.current = String(i === index);
        beat.inert = motion && i !== index;
        if (motion && i !== index) beat.setAttribute('aria-hidden','true');
        else beat.removeAttribute('aria-hidden');
      });
      this.querySelector('[data-bvs-counter]').textContent = motion ? String(index + 1).padStart(2,'0') : '01–03';
      this.style.setProperty('--bvs-progress', String(motion ? Math.max(.02,progress) : 1));
      this.story.style.setProperty('--bvs-turn', `${motion ? -7 + Math.sin(progress * Math.PI) * 14 : 0}deg`);
      this.story.style.setProperty('--bvs-x', `${motion ? Math.sin(progress * Math.PI * 2) * (mobile ? 9 : 25) : 0}px`);
      this.story.style.setProperty('--bvs-y', `${motion ? Math.cos(progress * Math.PI * 2) * 14 : 0}px`);
      this.story.style.setProperty('--bvs-orbit', `${motion ? -24 + progress * 85 : -24}deg`);
      this.story.style.setProperty('--bvs-glow', `${30 + progress * 40}%`);
      this.story.style.setProperty('--bvs-scale', String(motion ? .95 + Math.sin(progress * Math.PI) * .08 : 1));
      this.story.style.setProperty('--bvs-bg-x', `${motion ? -3 + progress * 6 : 0}%`);
      this.story.style.setProperty('--bvs-bg-y', `${motion ? 3 - progress * 6 : 0}%`);
      this.story.style.setProperty('--bvs-light-x', `${motion ? -30 + progress * 60 : 0}%`);
      this.toggle.setAttribute('aria-pressed', String(this.paused));
      this.toggle.textContent = this.paused ? this.dataset.motionResume : this.dataset.motionPause;
      this.dataset.bvsChapter = String(index);
    }
    cleanup() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.beats?.forEach(beat => { beat.inert = false; beat.removeAttribute('aria-hidden'); });
      this.dataset.bvsMotion = 'false';
      delete this.dataset.bvsReady;
    }
    disconnectedCallback() { this.cleanup(); }
  }
  customElements.define('bp-beautyves-story', BeautyVesStory);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('bp-beautyves-story').forEach(element => element.connectedCallback());
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bp-bpc-value"] && !Shopify.designMode) return;
  try {
    (()=>{
const registerBpcValue=()=>{
if(!customElements.get('bp-bpc-value')){
  class BpcValue extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();this.frame=0;this.visible=false;this.paused=this.paused||false;
      this.button=this.querySelector('.bpcv-motion');this.chapters=[...this.querySelectorAll('[data-chapter]')];
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      const signal=this.controller.signal;
      this.updateMotion=()=>{this.dataset.motion=String(!this.motion.matches&&!this.paused);this.button.hidden=this.hasAttribute('data-natural-motion')||this.motion.matches;this.button.setAttribute('aria-pressed',String(this.paused));this.button.setAttribute('aria-label',this.paused?this.button.dataset.resume:this.button.dataset.pause);this.schedule();};
      this.button.addEventListener('click',()=>{this.paused=!this.paused;this.updateMotion();},{signal});
      this.motion.addEventListener('change',this.updateMotion,{signal});
      window.addEventListener('scroll',()=>this.schedule(),{signal,passive:true});
      window.addEventListener('resize',()=>this.schedule(),{signal,passive:true});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();},{rootMargin:'80px'});this.observer.observe(this);
      this.updateMotion();this.dataset.ready='true';
    }
    schedule(){if(!this.visible||this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;if(!this.isConnected||!this.controller)return;const focus=innerHeight*.55;let index=0;this.chapters.forEach((chapter,i)=>{if(chapter.getBoundingClientRect().top<=focus)index=i;});this.chapters.forEach((chapter,i)=>{chapter.dataset.current=String(index===i);});this.querySelectorAll('.bpcv-nav a').forEach((link,i)=>{if(index===i)link.setAttribute('aria-current','step');else link.removeAttribute('aria-current');});if(this.dataset.motion==='true'){const rect=this.querySelector('.bpcv-story').getBoundingClientRect();const p=Math.min(1,Math.max(0,(innerHeight*.5-rect.top)/Math.max(1,rect.height-innerHeight*.4)));this.style.setProperty('--bpcv-progress',p.toFixed(4));}});}
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();cancelAnimationFrame(this.frame);this.frame=0;delete this.dataset.ready;}
  }
  customElements.define('bp-bpc-value',BpcValue);
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('bp-bpc-value').forEach(element=>element.disconnectedCallback()));
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('bp-bpc-value').forEach(element=>element.connectedCallback()));
}
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',registerBpcValue,{once:true});else registerBpcValue();
})();
(()=>{
const tag='bp-bpc-natural-motion';
if(customElements.get(tag))return;
const clamp=value=>Math.max(0,Math.min(1,value));
class BpcNaturalMotion extends HTMLElement{
  connectedCallback(){
    if(this.abort)return;
    if(!this.querySelector('video')||!this.querySelector('img')||!this.querySelector('canvas')){
      if(!this.pendingObserver){
        this.pendingObserver=new MutationObserver(()=>{
          if(this.querySelector('video')&&this.querySelector('img')&&this.querySelector('canvas')){
            this.pendingObserver.disconnect();this.pendingObserver=null;this.connectedCallback();
          }
        });
        this.pendingObserver.observe(this,{childList:true,subtree:true});
      }
      return;
    }
    this.pendingObserver?.disconnect();this.pendingObserver=null;
    this.abort=new AbortController();
    const signal=this.abort.signal;
    this.video=this.querySelector('video');
    this.poster=this.querySelector('img');
    this.canvas=this.querySelector('canvas');
    this.ctx=this.canvas?.getContext('2d',{willReadFrequently:true});
    this.maskCanvas=document.createElement('canvas');
    this.maskCtx=this.maskCanvas.getContext('2d',{willReadFrequently:true});
    this.visible=false;this.loaded=false;this.failed=false;this.desired=0;this.frame=0;this.timer=0;
    this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
    this.connection=navigator.connection;
    this.dataset.state='poster';
    if(!this.video||!this.poster||!this.canvas||!this.ctx||!this.maskCtx||!('IntersectionObserver' in window))return;
    this.reduced.addEventListener('change',()=>this.preferenceChanged(),{signal});
    this.connection?.addEventListener?.('change',()=>this.preferenceChanged(),{signal});
    window.addEventListener('scroll',()=>this.schedule(),{signal,passive:true});
    window.addEventListener('resize',()=>this.schedule(),{signal,passive:true});
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)this.schedule();},{signal});
    this.video.addEventListener('loadedmetadata',()=>this.metadata(),{signal});
    this.video.addEventListener('loadeddata',()=>this.ready(),{signal});
    this.video.addEventListener('seeked',()=>this.seeked(),{signal});
    this.video.addEventListener('error',()=>{if(this.loaded&&!this.suspending)this.fail('decode');},{signal});
    this.observer=new IntersectionObserver(entries=>{
      this.visible=entries[0].isIntersecting&&entries[0].intersectionRatio>0;
      if(this.visible&&this.allowed())this.load();
      if(this.visible)this.schedule();
    },{threshold:0});
    this.observer.observe(this);
  }
  allowed(){return !this.reduced.matches&&!this.connection?.saveData&&!this.failed;}
  load(){
    if(!this.visible||!this.allowed()||this.loaded)return;
    this.loaded=true;this.dataset.state='loading';
    this.video.crossOrigin='anonymous';
    this.video.src=this.dataset.src;
    this.video.load();
    this.timer=window.setTimeout(()=>this.fail('timeout'),15000);
  }
  metadata(){
    const width=Number(this.dataset.width),height=Number(this.dataset.height);
    const fps=Number(this.dataset.fps),frames=Number(this.dataset.frames);
    const duration=frames/fps;
    if(!width||width%2||!height||!fps||!frames||this.video.videoWidth!==width||this.video.videoHeight!==height||!Number.isFinite(this.video.duration)||Math.abs(this.video.duration-duration)>.35){this.fail('metadata');return;}
    this.canvas.width=width/2;this.canvas.height=height;
    this.maskCanvas.width=width/2;this.maskCanvas.height=height;
    this.schedule();
  }
  ready(){
    if(this.failed||!this.loaded)return;
    window.clearTimeout(this.timer);this.timer=0;
    this.schedule();
  }
  schedule(){
    if(!this.visible||!this.allowed()||document.hidden||this.frame)return;
    this.frame=requestAnimationFrame(()=>{this.frame=0;this.seekToScroll();});
  }
  seekToScroll(){
    if(!this.visible||!this.allowed()||document.hidden||!this.loaded||this.video.readyState<2||!this.canvas.width)return;
    const story=this.closest('.bpcv-story')||this;
    const stage=matchMedia('(max-width: 749px)').matches?(this.closest('.bpcv-image-mount')||this):story;
    const rect=stage.getBoundingClientRect();
    const progress=clamp((innerHeight-rect.top)/Math.max(1,rect.height+innerHeight));
    const fps=Number(this.dataset.fps);
    this.desired=progress*Math.max(0,Math.min(this.video.duration,Number(this.dataset.frames)/fps)-1/fps);
    if(this.video.seeking)return;
    if(Math.abs(this.video.currentTime-this.desired)>Math.max(.025,1/(fps*2))){
      try{this.video.currentTime=this.desired;}catch{this.fail('seek');}
      return;
    }
    this.render();
  }
  seeked(){
    if(!this.visible||!this.allowed()||document.hidden)return;
    this.render();
    if(Math.abs(this.video.currentTime-this.desired)>.04)this.schedule();
  }
  render(){
    if(!this.visible||!this.allowed()||document.hidden||this.video.seeking||this.video.readyState<2)return;
    const width=this.canvas.width,height=this.canvas.height;
    if(!width||!height)return;
    try{
      this.ctx.drawImage(this.video,0,0,width,height,0,0,width,height);
      const rgb=this.ctx.getImageData(0,0,width,height);
      this.maskCtx.drawImage(this.video,width,0,width,height,0,0,width,height);
      const mask=this.maskCtx.getImageData(0,0,width,height).data;
      for(let i=0;i<rgb.data.length;i+=4)rgb.data[i+3]=mask[i];
      this.ctx.putImageData(rgb,0,0);
      this.canvas.hidden=false;this.poster.hidden=true;this.dataset.state='ready';
    }catch{this.fail('canvas');}
  }
  preferenceChanged(){
    if(!this.allowed())this.suspend();
    else if(this.visible)this.load();
  }
  suspend(){
    window.clearTimeout(this.timer);this.timer=0;
    if(this.frame)cancelAnimationFrame(this.frame);this.frame=0;
    this.canvas.hidden=true;this.poster.hidden=false;this.dataset.state=this.failed?'error':'poster';
    this.suspending=true;this.loaded=false;
    this.video.pause();this.video.removeAttribute('src');this.video.load();
    this.suspending=false;
  }
  fail(reason){
    if(this.failed)return;
    this.failed=true;this.dataset.failure=reason;this.suspend();
  }
  disconnectedCallback(){
    this.pendingObserver?.disconnect();this.pendingObserver=null;
    this.abort?.abort();this.abort=null;
    this.observer?.disconnect();this.observer=null;
    if(this.video)this.suspend();
  }
}
customElements.define(tag,BpcNaturalMotion);
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll(tag).forEach(element=>element.disconnectedCallback()));
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll(tag).forEach(element=>element.connectedCallback()));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bp-mystery-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
  const instances = new Map();
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const compactQuery = window.matchMedia('(max-height: 740px)');

  function mount(root) {
    if (instances.has(root)) return;
    const story = root.querySelector('.bpmr-story');
    const stage = root.querySelector('.bpmr-stage');
    const reading = root.querySelector('.bpmr-reading');
    const chapters = [...root.querySelectorAll('[data-bpmr-chapter]')];
    const toggle = root.querySelector('[data-bpmr-toggle]');
    const sectionId = root.dataset.sectionId;
    const owner = root.closest('[id^="shopify-section-"]') || document;
    let frame = 0;
    let factFrame = 0;
    let visible = false;
    let paused = false;
    let ready = false;
    let active = 0;
    const cleanup = [];
    const on = (target, name, handler, options) => { target.addEventListener(name, handler, options); cleanup.push(() => target.removeEventListener(name, handler, options)); };
    const selectedId = () => {
      const form = document.getElementById(`product-form-${sectionId}`);
      const field = form && form.querySelector('[name="id"]');
      if (field && field.value) return field.value;
      const urlId = new URL(location.href).searchParams.get('variant');
      return urlId || root.dataset.activeVariant;
    };
    const syncFacts = () => {
      const row = [...root.querySelectorAll('[data-bpmr-variant]')].find(item => item.dataset.bpmrVariant === selectedId());
      const valid = row && row.dataset.valid === 'true';
      root.querySelector('[data-bpmr-fact-list]').hidden = !valid;
      root.querySelector('[data-bpmr-unavailable]').hidden = Boolean(valid);
      if (!valid) return;
      root.querySelector('[data-bpmr-minimum]').textContent = row.dataset.minimum;
      root.querySelector('[data-bpmr-price]').textContent = row.dataset.price;
      root.querySelector('[data-bpmr-quantity]').textContent = row.dataset.quantity;
    };
    const scheduleFacts = () => { if (!factFrame) factFrame = requestAnimationFrame(() => { factFrame = 0; syncFacts(); }); };
    const setActive = index => {
      active = index;
      chapters.forEach((chapter, i) => { chapter.dataset.current = String(i === index); });
      root.querySelector('[data-bpmr-number]').textContent = String(index + 1).padStart(2, '0');
    };
    const storyProgress = () => {
      const rect = story.getBoundingClientRect();
      const travel = Math.max(1, rect.height - window.innerHeight);
      return Math.max(0, Math.min(1, -rect.top / travel));
    };
    const phase = (progress, start, end) => {
      const t = Math.max(0, Math.min(1, (progress - start) / (end - start)));
      return t * t * (3 - 2 * t);
    };
    const render = () => {
      frame = 0;
      if (!ready || !visible) return;
      const progress = storyProgress();
      const chapter = Math.min(3, Math.floor(progress * 4));
      setActive(chapter);
      const orbit = phase(progress, 0, .26);
      const macro = phase(progress, .16, .45);
      const opening = phase(progress, .42, .86);
      const flare = phase(progress, .68, .98);
      root.style.setProperty('--bpmr-progress', progress.toFixed(4));
      if (paused) return;
      root.dataset.lidBack = String(opening * 148 >= 92);
      const desktopScale = .87 + orbit * .18 + macro * .25 - opening * .62 + flare * .11;
      const mobileScale = .9 + orbit * .1 + macro * .2 - opening * .5 + flare * .25;
      root.style.setProperty('--bpmr-rig-scale', (window.innerWidth <= 600 ? mobileScale : desktopScale).toFixed(4));
      root.style.setProperty('--bpmr-rig-y', `${(-macro * 12 + opening * 48).toFixed(1)}px`);
      root.style.setProperty('--bpmr-camera-x', `${(54 + orbit * 6 - macro * 4 - opening * 16).toFixed(2)}deg`);
      root.style.setProperty('--bpmr-camera-y', `${(-31 + orbit * 30 - macro * 8 - opening * 9).toFixed(2)}deg`);
      root.style.setProperty('--bpmr-lid-angle', `${(opening * 148).toFixed(2)}deg`);
      root.style.setProperty('--bpmr-inner-visible', phase(progress, .66, .8).toFixed(3));
      root.style.setProperty('--bpmr-flap-print', (1 - phase(progress, .55, .74)).toFixed(3));
      root.style.setProperty('--bpmr-foil-track', `${((macro * .87 + opening * .08) * 100).toFixed(2)}%`);
      root.style.setProperty('--bpmr-light', (opening * .08 + flare * .92).toFixed(3));
      root.style.setProperty('--bpmr-rays', (flare * .68).toFixed(3));
      root.style.setProperty('--bpmr-bounce', (opening * .08 + flare * .48).toFixed(3));
      root.style.setProperty('--bpmr-lid-bounce', (opening * .09 + flare * .73).toFixed(3));
      root.style.setProperty('--bpmr-aperture', (opening * .13 + flare * .87).toFixed(3));
      root.style.setProperty('--bpmr-bloom', (flare * .74).toFixed(3));
      root.style.setProperty('--bpmr-shadow-scale', (1 + opening * .09).toFixed(3));
      root.style.setProperty('--bpmr-particles', Math.max(0, (flare - .48) * .8).toFixed(3));
    };
    const request = () => { if (!frame && ready && visible) frame = requestAnimationFrame(render); };
    const mode = () => {
      ready = !motionQuery.matches && !compactQuery.matches && window.innerWidth >= 360;
      root.dataset.motion = String(ready);
      if (ready) {
        const stageBox = stage.getBoundingClientRect();
        const readingBox = reading.getBoundingClientRect();
        if (readingBox.top < stageBox.top + 56 || readingBox.bottom > stageBox.bottom - 52) {
          ready = false;
          root.dataset.motion = 'false';
        }
      }
      if (!ready) {
        cancelAnimationFrame(frame); frame = 0; paused = false; root.removeAttribute('data-paused');
        root.removeAttribute('data-lid-back');
        toggle.setAttribute('aria-pressed', 'false'); toggle.textContent = toggle.dataset.pauseLabel;
        ['--bpmr-lid-angle','--bpmr-rig-scale','--bpmr-rig-y','--bpmr-camera-x','--bpmr-camera-y','--bpmr-inner-visible','--bpmr-flap-print','--bpmr-light','--bpmr-rays','--bpmr-bounce','--bpmr-lid-bounce','--bpmr-aperture','--bpmr-bloom','--bpmr-shadow-scale','--bpmr-particles','--bpmr-foil-track'].forEach(name => root.style.removeProperty(name));
        chapters.forEach(chapter => chapter.dataset.current = 'true');
      } else { setActive(Math.min(3, Math.floor(storyProgress() * 4))); request(); }
    };
    const intersection = new IntersectionObserver(entries => { visible = entries.some(entry => entry.isIntersecting); request(); }, { rootMargin: '20% 0px' });
    const fitObserver = new ResizeObserver(() => { if (ready) mode(); });
    intersection.observe(story);
    fitObserver.observe(reading);
    on(window, 'scroll', request, { passive: true });
    on(window, 'resize', mode, { passive: true });
    on(motionQuery, 'change', mode);
    on(compactQuery, 'change', mode);
    on(owner, 'change', scheduleFacts);
    on(owner, 'variant:change', scheduleFacts);
    on(owner, 'variant:changed', scheduleFacts);
    on(owner, 'product:variant-change', scheduleFacts);
    on(owner, 'variantChangeEnd', scheduleFacts);
    on(window, 'popstate', scheduleFacts);
    on(toggle, 'click', () => { paused = !paused; toggle.setAttribute('aria-pressed', String(paused)); toggle.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel; root.dataset.paused = String(paused); request(); });
    mode();
    syncFacts();
    instances.set(root, () => { cancelAnimationFrame(frame); cancelAnimationFrame(factFrame); intersection.disconnect(); fitObserver.disconnect(); cleanup.forEach(fn => fn()); instances.delete(root); });
  }

  function mountAll(scope = document) { scope.querySelectorAll('bp-mystery-reveal').forEach(mount); }
  function unmountAll(scope) { scope.querySelectorAll('bp-mystery-reveal').forEach(root => instances.get(root)?.()); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountAll(), { once: true });
  else mountAll();
  document.addEventListener('shopify:section:unload', event => unmountAll(event.target));
  document.addEventListener('shopify:section:load', event => mountAll(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
